import React, { useEffect, useState } from 'react'
import { getCourseLessonGradeYearReports, saveOverviewTexts, getOverviewTexts } from '../../../lib/studentcourselessonreport'
import { ReportCard, ToastNotification, OverviewTextarea, UpdateButton } from './CourseReportComponents'
import { getHeaderClass, sortLevels } from './CourseReportUtils'
import style from './CourseReportStyles.module.css'

const OVERVIEW_KEY = 'gradeYear'

export const CourseLessonGradeYearReport = ({ studentId, isStudent = false }) => {
	const [data, setData] = useState([])
	const [levels, setLevels] = useState([])
	const [overview, setOverview] = useState({})
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)

	useEffect(() => {
		loadData()
	}, [studentId])

	const loadData = async () => {
		const res = await getCourseLessonGradeYearReports(studentId)
		const sorted = [...res].sort((a, b) => a.courseyear - b.courseyear)
		setData(sorted)

		// Dinamik seviyeleri belirle (Total, studentId hariç)
		const dynamicLevels = new Set()
		sorted.forEach((row) => {
			Object.keys(row).forEach((key) => {
				if (!['courseyear', 'studentId', 'Total'].includes(key)) {
					dynamicLevels.add(key)
				}
			})
		})

		setLevels(sortLevels([...dynamicLevels]))

		const overviewRes = await getOverviewTexts(studentId)
		const overviewMap = {}
		overviewRes.forEach((item) => {
			overviewMap[item.type] = item.desc
		})
		setOverview(overviewMap)
	}

	const handleOverviewChange = (value) => {
		setOverview((prev) => ({ ...prev, [OVERVIEW_KEY]: value }))
	}

	const handleUpdate = async () => {
		await saveOverviewTexts(studentId, { [OVERVIEW_KEY]: overview[OVERVIEW_KEY] || '' })
		setToastMessage('Update successful!')
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
		loadData()
	}

	const getLevelTotal = (level) => data.reduce((sum, row) => sum + (row[level] ?? 0), 0).toFixed(1)

	const getRowTotal = (row) => levels.reduce((sum, lvl) => sum + (row[lvl] ?? 0), 0).toFixed(1)

	return (
		<ReportCard title="Number of Credits">
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />

			<table className="table table-bordered text-center">
				<thead>
					<tr>
						<th style={{ width: '150px' }}>Grade</th>
						<th>Total</th>
						{levels.map((lvl) => (
							<th key={lvl} className={style[getHeaderClass(lvl)]}>
								{lvl}
							</th>
						))}
						<th style={{ width: '400px' }}>Overview</th>
					</tr>
				</thead>
				<tbody>
					{data.map((row, index) => (
						<tr key={row.courseyear}>
							<td>{`Grade-${row.courseyear}`}</td>
							<td className={style.totalCell}>{getRowTotal(row)}</td>
							{levels.map((lvl) => (
								<td key={lvl} className={row[lvl] > 0 ? style[getHeaderClass(lvl)] : ''}>
									{(row[lvl] ?? 0).toFixed(1)}
								</td>
							))}
							{index === 0 && (
								<td rowSpan={data.length + 1} className={style.overviewCell}>
									<OverviewTextarea
										value={overview[OVERVIEW_KEY] || ''}
										onChange={handleOverviewChange}
										rows={data.length * 2}
										isStudent={isStudent}
									/>
								</td>
							)}
						</tr>
					))}

					<tr>
						<td>
							<strong>TOTAL</strong>
						</td>
						<td className={style.totalCell}>{data.reduce((sum, row) => sum + parseFloat(getRowTotal(row)), 0).toFixed(1)}</td>
						{levels.map((lvl) => (
							<td key={lvl} className={(getLevelTotal(lvl) > 0 ? style[getHeaderClass(lvl)] : '') + ' fw-bold'}>
								{getLevelTotal(lvl)}
							</td>
						))}
					</tr>
				</tbody>
			</table>

			<UpdateButton onClick={handleUpdate} isStudent={isStudent} />
		</ReportCard>
	)
}
